module.exports = 'ttb.dashboard.completedStoryPoints.component';

angular.module(module.exports, [])
    .component('completedStoryPoints', {
        template: `<div ng-cloak class="widget-simple-chart text-right card-box">
                       <div class ="circliful-chart completed-sp" circliful circliful-percent="$ctrl.data.passedPercents"
                        circliful-fg-color="#f76397" circliful-bg-color="#ebeff2"></div>
                       <h3 class ="text-success">{{$ctrl.info}}</h3>
                       <p class="text-muted text-nowrap" translate>DashBoard_Burned_Story_Points</p>
                   </div>`,
        controller: CompletedStoryPoints,
        bindings: {
            team: '<'
        }
    });

function CompletedStoryPoints($http, completedSPUrl) {
    this.$onChanges = (changes) => {
        if (changes.team) {
            if (changes.team.currentValue !== undefined) {
                this.load(changes.team.currentValue);
            }
            else {
                this.update({ passedPercents: 0, burned: 0, total: 0 });
            }
        }
    }

    this.update = (data) => {
        this.data = data;
        this.info = `${data.burned}/${data.total}`;
    }

    this.load = (team) => {
        this.loading = true;
        this.info = 'loading...';

        $http.get(completedSPUrl, { params: { teamId: team ? team.id : null, timestamp: new Date() } })
            .then(response => {
                    this.loading = false;
                    this.update(response.data);
                },
                () => {
                    this.loading = false;
                });
    }
}
CompletedStoryPoints.$inject = ['$http', 'completedSPUrl'];


// WEBPACK FOOTER //
// ./components/completed-story-points/completed-story-points.component.js